import { CalendarAccountErrorDialogState } from '../schema/CalendarAccountErrorDialogState';
import {
    removedIdsTitle,
    accountNotAvailable,
    failedToConnect_tryagain_MessageEdu,
    failedToConnect_tryagain_Message,
    removedIdsSubtext,
    failedToConnect_reconnect_MessageEdu,
    failedToConnect_reconnect_Message,
} from '../components/OWAAccountsErrorDialog.locstring.json';
import loc from 'owa-localize';
import { isEduStudent } from 'owa-bpos-utils';

export function getDialogTitle(errorState: CalendarAccountErrorDialogState) {
    return errorState == CalendarAccountErrorDialogState.AccountLoadTokenError ||
        errorState == CalendarAccountErrorDialogState.AccountLoadNonTokenError
        ? loc(accountNotAvailable)
        : loc(removedIdsTitle);
}

export function getDialogSubtext(errorState: CalendarAccountErrorDialogState) {
    const isTokenError = errorState == CalendarAccountErrorDialogState.AccountLoadTokenError;
    return errorState == CalendarAccountErrorDialogState.RemovedCalendarIds
        ? loc(removedIdsSubtext)
        : isTokenError && isEduStudent()
        ? loc(failedToConnect_tryagain_MessageEdu)
        : isTokenError && !isEduStudent()
        ? loc(failedToConnect_tryagain_Message)
        : isEduStudent()
        ? loc(failedToConnect_reconnect_MessageEdu)
        : loc(failedToConnect_reconnect_Message);
}
